import React from "react";
import "./movie-card.scss";
import { Link } from "react-router-dom";
import Button from "../button/Button";
import { category } from "../../api/tmdbApi";
import apiConfig from "../../api/apiConfig";

const MovieCard = ({ item, cat }) => {
  // console.log(item);
  const link =
    cat === "anime"
      ? // ? "/" + category[cat] + "/" + item?.mal_id
        "/" + category[cat]
      : "/" + category[cat] + "/" + item.id;
  const bg =
    cat === "anime"
      ? item?.images?.jpg?.large_image_url ||
        item?.entry?.images?.jpg?.large_image_url
      : apiConfig.w500Image(item.poster_path || item.backdrop_path);

  return (
    <Link to={link}>
      <div className="movie-card" style={{ backgroundImage: `url(${bg})` }}>
        <Button>
          <i className="bx bx-play"></i>
        </Button>
      </div>
      <h3>{item.title || item.name || item.entry.title}</h3>
    </Link>
  );
};

export default MovieCard;
